import { DropDownList, DropDownListProps } from '@progress/kendo-react-dropdowns';
import styled, { createGlobalStyle } from 'styled-components';

export const DropDownGlobalStyle = createGlobalStyle`
    .app-dropdown-popup {
        &&& {
            background: transparent !important;

            .k-popup {
                font-size: 1em;

                > div:not(:empty) {
                    padding: 0.71em 0;
                }

                .k-list-item {
                    padding: 0 0.71em;
                }
            }

            &.app-dropdown-popup-small {
                //font-size: 0.71rem;

                .k-popup {
                    min-width: unset !important;
                }

                .k-list {
                    .k-list-item {
                        padding-left: 0.71em;
                        padding-right: 0.71em;
                        font-size: 0.71em !important;
                        line-height: 1.57em !important;
                        letter-spacing: 0.4px !important;
                    }
                }

                .k-list-scroller {
                    padding-bottom: 0.36em;
                }
            }
        }
    }
`;

export type DropDownProps = DropDownListProps & {
    small?: boolean;
};

export const DropDown = styled(DropDownList)
    .withConfig({ shouldForwardProp: (prop) => !['small'].includes(prop) })
    .attrs<DropDownProps>((props: DropDownProps) => ({
        popupSettings: {
            className: `app-dropdown-popup ${props.small ? 'app-dropdown-popup-small' : ''}`,
        },
        className: `app-dropdown ${props.small ? 'app-dropdown-small' : ''} ${props.className || ''}`,
        small: false,
    }))`
    &&&.app-dropdown {
        font-size: 1em;
        font-style: normal;
        font-weight: bold;

        width: clamp(80px, 11vw, 200px);

        border: none !important;
        background: white !important;
        box-shadow: none !important;

        &[aria-expanded='true'] .k-icon:before {
            content: '\\e013';
        }

        &[aria-expanded='false'] .k-icon:before {
            content: '\\e015';
        }

        .k-input-inner {
            font-size: 1em;
            padding: 0.66em 0;
            color: ${(props) => props.theme.colors.base_grey};
            height: calc(0.85em + 1vw);
        }

        .k-button {
            font-size: 1em;
            padding-top: 0;
            padding-bottom: 0;
            opacity: 0.54;

            &:before {
                display: none;
            }
        }

        &:hover {
            .k-button {
                opacity: 0.87;
            }
        }

        &.k-focus {
            &:after {
                display: none;
            }
        }

        &.app-dropdown-small {
            font-size: 0.71em !important;
            height: 1em !important;

            .k-input-inner {
                font-size: 0.71em !important;
                line-height: 1em !important;
                padding: 0 !important;
                height: auto !important;
            }

            .k-button {
                padding-top: 0 !important;
                padding-bottom: 0 !important;
                height: auto;
            }
        }
    }
`;
